// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1GK9J","content":"LoadingAlert_content__LxIlX"};